var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: (_vm.visible && _vm.hasGroups) || _vm.hasNoMatches,
          expression: "(visible && hasGroups) || hasNoMatches"
        }
      ],
      staticClass: "menu-groups",
      style: _vm.menuStyle
    },
    [
      _c(
        "div",
        { staticClass: "menu-groups__groups" },
        _vm._l(_vm.groups, function(group) {
          return _c(
            "div",
            { key: group.name, staticClass: "menu-groups__group" },
            [
              _c("h3", { staticClass: "menu-groups__group-label" }, [
                _vm._v(_vm._s(group.name))
              ]),
              _c(
                "ul",
                { staticClass: "menu-groups__items" },
                [
                  _vm._l(group.options, function(option) {
                    return _c("DropdownMenuItem", {
                      key: option.value,
                      attrs: {
                        text: option.text,
                        value: option.value,
                        iconClass: option.iconClass,
                        disabled: option.disabled,
                        defaultItemClass: _vm.menuItemClass
                      },
                      on: { itemClick: _vm.onSelect }
                    })
                  }),
                  _vm.hasNoMatches
                    ? _c("div", { staticClass: "menu-groups__no-matches" }, [
                        _c("span", [_vm._v("No matches found")])
                      ])
                    : _vm._e()
                ],
                2
              )
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }